module.exports = __webpack_public_path__ + "img/big-map.bb9027b.svg";